import styled, { css } from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgType?: 'white' | 'black' | 'transparent' | string;
}

export const Header = styled.header<IProps>`
  font-family: 'Pretendard Variable', Pretendard, -apple-system,
    BlinkMacSystemFont, 'Apple SD Gothic Neo', Roboto, 'Noto Sans KR',
    'Segoe UI', 'Malgun Gothic', 'Apple Color Emoji', 'Segoe UI Emoji',
    'Segoe UI Symbol', sans-serif;

  position: relative;
  width: 100%;
  height: 50px;
  z-index: 100;

  .inner-header {
    width: inherit;
    height: inherit;
    background-color: #fff;

    .area-right {
      display: inline-flex;
      z-index: 1;

      .btn {
        margin-left: 6px;

        &:first-child {
          margin-left: 0;
        }
        svg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .title {
      position: relative;
      width: 100%;
      height: 50px;
      line-height: 50px;
      text-align: center;
      z-index: 0;
      font-size: 17px;
      font-weight: 600;

      span {
        ${mixin.ellipsis(1)};
      }
    }

    .cate-title {
      .btn {
        gap: 8px;
      }

      &.active {
        svg {
          transform: rotate(180deg);
        }
      }
    }

    .btn-home,
    .btn-profile,
    .btn-alarm,
    .btn-search,
    .btn-cart {
      width: 32px;
      height: 32px;
      position: relative;
    }

    .btn-alarm.dot::after {
      content: '';
      display: inline-block;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: #ff4600;
      position: absolute;
      top: 4px;
      right: 4px;
    }

    .btn-cart {
      position: relative;
      ${mixin.flex({ justify: 'flex-start' })}

      .count {
        position: absolute;
        left: 12px;
        bottom: 0;
        margin-left: 0;
        font-size: 10px;
      }

      svg {
        margin-left: -3px;
      }
    }

    .btn-logo {
      ${mixin.flex({ justify: 'flex-start' })}
      width: 195px;
      height: 50px;
      padding-left: 20px;

      .img {
        width: 195px;
        height: 50px;
      }
    }
  }

  .header-main {
    height: inherit;
    ${mixin.flex({ justify: 'space-between' })}
    padding: 0px 10px 0px 0px;

    .btn-logo {
      &.type-evt {
        height: inherit;
        overflow: hidden;
        padding-left: 0;

        svg {
          width: 195px !important;
          height: 50px !important;
        }

        .img {
          width: 195px;
          height: 50px;
        }
      }
    }
  }

  .header-subPage {
    height: inherit;
    padding: 0px 10.5px 0px 0px;
    ${mixin.flex({ justify: 'space-between' })};

    .title {
      padding: 0 4px 0 20px;
      text-align: left;
      font-size: 18px;
    }

    .area-right {
      position: relative;
      right: auto;
    }

    .tabs-title-btn {
      margin-left: 20px;
    }
  }

  .header-subDetail {
    height: inherit;
    padding: 0px 20px;
    ${mixin.flex({ justify: 'space-between' })};

    .area-left {
      position: absolute;
      left: 14px;
      z-index: 1;
      .modal-back-btn {
        svg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
        }
      }
    }

    .area-right {
      position: absolute;
      right: 10px;
    }

    .title {
      span {
        max-width: ${mixin.pxToVw('210')};
        margin: 0 auto;
      }
    }
  }

  ${props => {
    if (props.$bgType === 'black') {
      return css`
        .inner-header {
          background-color: #1a1a1a;

          svg {
            path,
            rect {
              fill: #fff;
            }
          }

          .title {
            color: #fff;
          }

          .btn-cart .count {
            background-color: #fff;
            color: #000;
          }
        }
      `;
    }
    if (props.$bgType === 'transparent') {
      return css`
        .inner-header {
          background: transparent;

          svg {
            path,
            rect {
              fill: #fff;
            }
          }

          .btn-cart .count {
            color: #000;
            background-color: #fff;
          }

          .title {
            color: #fff;
          }
        }
      `;
    }
    return null;
  }}
`;
